import { Typography } from '../../designComponents';
import Timeline from '../../designComponents/Timeline';
import { InfoRowStyled } from '../../style/reusableStyle';
import { JobDetailsContainerStyled } from './style';

type Props = {
  events?: {
    date: string;
    title: string;
    description?: string;
  }[];
};

const JobTimeline = ({ events = [] }: Props) => {
  return (
    <JobDetailsContainerStyled>
      <Typography
        variant="normal"
        className="title"
        fontColor="secondary"
        strong
      >
        JOB TIMELINE
      </Typography>
      <InfoRowStyled>
        <Typography className="title"> </Typography>
        {/* <Typography className="value">Kathmandu Mall</Typography> */}
        <Timeline events={events} />
      </InfoRowStyled>
    </JobDetailsContainerStyled>
  );
};

export default JobTimeline;
